import React, {Fragment} from 'react';
import debounce from 'lodash-es/debounce';
import Icon from "./../Icon";
import classNames from 'classnames';

class GridFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            on: !!this.props.value,
            value: this.props.value
        };
    }

    componentDidMount() {
        if (this.props.delay) {
            this.debounce = debounce((field, value) => {
                this.props.saveChanges(field, value);
            }, this.props.delay);
        }
    }

    componentWillUnmount() {
        if (this.debounce) {
            this.debounce.cancel();
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.value !== prevProps.value) {
            if (this.props.value) {
                const newState = {on: true};
                if (!this.debounce) {
                    newState.value = this.props.value;
                }
                this.setState(newState);
            } else if(this.props.value === undefined) {
                const newState = {on: false};
                if (!this.debounce) {
                    newState.value = this.props.value;
                }
                this.setState(newState);
            }
        }
    }

    saveChanges = (field, value) => {
        this.setState({value: value});
        if (this.debounce) {
            this.debounce(field, value);
        } else {
            this.props.saveChanges(field, value);
        }
    }

    toggle = () => {
        if (this.state.on === true) {
            this.setState({on: false});
            this.saveChanges(this.getFieldName(), null);
        } else {
            this.setState({on: true}, () => {
                this.input && this.input.focus && this.input.focus();
                this.saveChanges(this.getFieldName(), this.props.value || this.state.value);
            });
        }
    }

    getFieldName = () => {
        return this.props.filterField || this.props.field;
    }

    render() {
        let input = null;
        if (this.props.children) {
            if (this.props.children instanceof Function) {
                input = this.props.children({
                    ref: (input) => this.input = input,
                    saveChanges: this.saveChanges,
                    name: this.getFieldName(),
                    value: this.state.value
                });
            } else {
                input = React.Children.map(this.props.children, (child) => {
                    return <child.type {...{
                        ...child.props,
                        ref: (input) => this.input = input,
                        saveChanges: this.saveChanges,
                        name: this.getFieldName(),
                        value: this.state.value
                    }} />
                });
            }
        } else {
            input = <input
                    ref={(input) => this.input = input}
                    className="p-inputtext p-component form-control filterinput"
                    type="text"
                    onChange={(e) => (this.saveChanges(null, e.target.value))}
                    value={this.state.value || ''}
            />;
        }
        return (
            <Fragment>
                <div className={"filter-button"} onClick={this.toggle}><Icon name="search"/></div>
                <div className={(this.state.on === true ? "filter-enabled" : "filter-disabled")}>
                    {input}
                </div>
            </Fragment>
        );
    }
}

export default GridFilter;